<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-sm-12 col-lg-6 mb-1">
              <div class="dataTables_length" id="tickets-table_length">
                <label class="d-inline-flex align-items-center">
                  Afișează
                  <select
                    aria-controls="tickets-table"
                    name="pageSize"
                    [(ngModel)]="incasariTableService.pageSize"
                    [disabled]="loadingDataSpinner"
                    (change)="changeTableRows($event)"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2"
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  intrări
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-lg-6 mb-1">
              <div
                id="tickets-table_filter"
                class="d-flex justify-content-end"
              >
                <button
                  class="btn btn-info btn-sm"
                  type="button"
                  placement="left"
                  [disabled]="loadingDataSpinner"
                  (click)="openTableSearchModal()"
                >
                  <span class="mdi mdi-magnify"></span>
                  Căutare
                </button>
              </div>
            </div>
            <!-- End search -->
          </div>

          <!-- Table -->
          <div class="table-responsive" #incasariTable>
            <table
              id="incasari-datatable"
              class="table datatables dt-responsive nowrap table-hover"
            >
              <thead>
                <tr>
                  <th sortable="exploatatie" (sort)="onSort($event)">
                    Exploatația
                  </th>
                  <th sortable="seria" (sort)="onSort($event)">
                    Chitanță Serie/Nr
                  </th>
                  <th sortable="valoare" (sort)="onSort($event)">
                    Valoare
                  </th>
                  <th scope="col">
                    Acțiuni
                  </th>
                </tr>
              </thead>

              <ngb-alert
                type="danger"
                class="text-center search-error"
                *ngIf="incasariTableService.totalRecords === 0"
                [dismissible]="false"
              >
                Nu a fost găsită nici o încasare.
              </ngb-alert>

              <div
                class="spinner-border text-info table-spinner avatar-lg"
                role="status"
                *ngIf="loadingDataSpinner"
              ></div>

              <tbody [ngClass]="{ disabled: loadingDataSpinner }">
                <tr *ngFor="let incasare of incasari">
                  <td>{{ incasare.company }}</td>
                  <td>{{ incasare.seria }}/{{ incasare.numar }}</td>
                  <td>
                    {{ incasare.valoare }}
                  </td>
                  <td>
                    <div class="btn-group" class="action-buttons">
                      <button
                        class="btn btn-sm btn-icon btn-success"
                        title="Vizualizează"
                        (click)="vizualizeazaIncasare(incasare.id)"
                      >
                        Vizualizează
                      </button>
                      <button
                        class="btn btn-sm btn-icon btn-primary"
                        title="Descarcă"
                        (click)="descarcaIncasare(incasare.id)"
                      >
                        Descarcă PDF
                      </button>
                      <button
                        class="btn btn-sm btn-icon btn-danger"
                        title="Anulează"
                        *ngIf="incasare.status !== 1 && incasare.status !== 2"
                        (click)="anuleazaIncasare(incasare.id)"
                      >
                        Anulează
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End table -->
          <div
            class="row justify-content-lg-between align-items-lg-center mt-2"
            *ngIf="incasariTableService.totalRecords > 0"
          >
            <div class="col-sm-12 col-lg-6">
              <div
                class="dataTables_info mb-2"
                id="tickets-table_info"
                role="status"
                aria-live="polite"
              >
                Afișează de la
                {{ incasariTableService.startIndex }} la
                {{ incasariTableService.endIndex }} din
                {{ incasariTableService.totalRecords }}
                intrări
              </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-lg-6">
              <div class="text-lg-right float-lg-right pagination-rounded">
                <ngb-pagination
                  [disabled]="loadingDataSpinner"
                  [collectionSize]="incasariLength"
                  [(page)]="incasariTableService.page"
                  [pageSize]="incasariTableService.pageSize"
                  [maxSize]="5"
                  (pageChange)="changeTablePage($event)"
                >
                </ngb-pagination>
              </div>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-table-search-modal
  [open]="openSearchModal"
  [modalType]="'chitante'"
  (searchingData)="filterSearch($event)"
>
</app-table-search-modal>
